<template>
    <v-container class="pa-4 fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="4">
          <h2 class="text-center mb-4">Recuperar senha</h2>
          <v-form @submit.prevent="onSubmit">
            <v-text-field
              v-model="email"
              label="Seu e-mail"
              required
              @input="error = ''"
            />
            <v-alert v-if="error" type="error" dense outlined>{{ error }}</v-alert>
            <v-alert v-if="success" type="success" dense outlined>{{ success }}</v-alert>
            <div class="text-center mt-4">
              <v-btn type="submit" color="primary">Enviar link</v-btn>
            </div>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { requestPasswordReset } from '../services/api';
  
  const email = ref('');
  const error = ref('');
  const success = ref('');
  
  async function onSubmit() {
    error.value = '';
    success.value = '';
    try {
      const res = await requestPasswordReset(email.value);
      success.value = res.message;
    } catch (err) {
      error.value = err.message;
    }
  }
  </script>
  